module.exports = __webpack_public_path__ + "img/deafultcatlogpic.2cc52859.jpeg";